export default __webpack_public_path__ + "static/media/AttachedDocuments.ecf5fb32.svg";